
define(
	'Tavanoteam.BackorderMessage.BackorderMessage'
	, [
		'Tavanoteam.BackorderMessage.BackorderMessage.View'

		, 'jQuery'
	]
	, function (
		BackorderMessageView

		, jQuery
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				// using the 'Layout' component we add a new child view inside the 'Header' existing view 
				// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
				// more documentation of the Extensibility API in
				// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

				/** @type {LayoutComponent} */
				var layout = container.getComponent('Layout');
				var cart = container.getComponent('Cart');
				var environment = container.getComponent('Environment');

				if (cart) {
					//Item.BackorderMessage on cart_lines.tpl
					cart.addChildView('Item.BackorderMessage', function () {
						return new BackorderMessageView({ container: container });
					});

				}

				if (layout) {
					layout.addToViewContextDefinition('Cart.Confirmation.View', 'isBackOrderMessage', 'boolean', function (context) {
						context.isBackOrderMessage = false;
						if (context.model.item && context.model.item.isinstock == 'No' || context.model.item && context.model.item.isinstock == false) {
							context.isBackOrderMessage = true;
						}
						return context.isBackOrderMessage;
					});

					layout.addToViewContextDefinition('Cart.Confirmation.View', 'backorderMessage', 'string', function (context) {
						return (context.model.item.outofstockmessage || SC.CONFIGURATION.TT.bkordermessage);
					});

					layout.addToViewEventsDefinition('Cart.Confirmation.View', 'click [data-action="show-message-cart"]', function (event) {

						if ($('.product-line-stock-msg-out').is(':hidden')) {
							$('.product-line-stock-msg-out').show();
						} else {
							$('.product-line-stock-msg-out').hide();
						}
					}
					);
				}

			}
		};
	});
